import React from 'react'
import './CountryMaps.css'
const CountryMaps = ({list}) =>{
    const [state,setState]=React.useState(list[0])
    console.log(state)
    return(
        <>
            <div className='map-container' >
                <div className='map-options-container' >
                    {
                    list.map(item=>{
                            return <>
                                <div onClick={()=>setState(item)} className={state.headline===item.headline? 'option-container-active':"option-container"} >
                                <p dangerouslySetInnerHTML={{__html:item.headline}}/>
                                </div>
                            </>
                        })
                    }
                </div>
                <img className='map-image' src={state.img} alt='mapa' />
            </div>
            <br/>
            <br/>
            <div className='references-container' >

                {
                    state.references?.map(item=>{
                        return <div className='map-ref' dangerouslySetInnerHTML={{__html:item.text}}></div>
                    })
                }
            </div>
        </>
    )
}
export default CountryMaps